import download from './download'
import {getMyDate} from "../utils/getDate";
import {getDictData} from "../utils/getDictDataList";
import {userRoot} from '../utils/userRoot'
import directive from './directive/index'

export default {
  install(Vue) {
    Vue.use(directive)
    // 下载文件
    Vue.prototype.$download = download
    Vue.prototype.getDate = getMyDate
    Vue.prototype.getDictData = getDictData
    Vue.prototype.userRoot = userRoot
  }
}
